import { addOrUpdateArrayItem } from "services/utils";
const reactTableUserManagement = {
  state: {
    filterValues: [],
    isRemovingFilters: false,
  },
  reducers: {
    addOrUpdateFilterValue: (state, newValue) => {
      const { id, value } = newValue;
      const filterItem = { id: id, value: value };
      const valuesArray = addOrUpdateArrayItem(
        state.filterValues,
        (item) => item.id === id,
        filterItem
      );
      return {
        ...state,
        filterValues: valuesArray,
      };
    },
    setIsRemovingFilters: (state) => {
      return {
        ...state,
        isRemovingFilters: true,
      };
    },
    resetFilters: (state) => {
      return {
        ...state,
        filterValues: [],
        isRemovingFilters: false,
      };
    },
  },
};

export default reactTableUserManagement;
